export default "__VITE_ASSET__DdYD0kqS__"